import React, { Component } from "react";
import axios from "axios";
import FeatherIcon from "feather-icons-react";
import Listprint from "../../Listprint";
import StudentLine from "./StudentLine";

class Reportcardnote extends Component {
  state = { rows: [], labels: [], data: [], loading: true, error: "" };
  componentDidMount() { this.getReportcards(); }
  matchesCategory = (periodId) => {
    if (this.props.category === "Examen") return periodId === 3 || periodId === 6;
    if (this.props.category === "Deuxieme session") return periodId === 7;
    return periodId !== 3 && periodId !== 6 && periodId !== 7;
  };
  getReportcards = async () => {
    try {
      const response = await axios.get(`/student/reportcards/${this.props.student}`);
      const evaluations = (response.data?.reportcards || []).filter((item) => this.matchesCategory(Number(item.periode?.id)));
      const rows = [], results = {};
      evaluations.forEach((evaluation) => {
        const periodId = Number(evaluation.periode?.id);
        const lesson = evaluation.sectionclasselesson?.lesson?.short_entitled_lesson || "Cours non renseigné";
        const max = periodId === 3 || periodId === 6 || periodId === 7
          ? Number(evaluation.sectionclasselesson?.max_exam || 0) : Number(evaluation.sectionclasselesson?.max_evaluation || 0);
        (evaluation.notes || []).forEach((note) => {
          const score = Number(note.note || 0);
          rows.push({ Periode: `${periodId}P`, lesson, note: `${score}/${max || "—"}`,
            staff: evaluation.sectionclasselesson?.staff?.user?.last_name || "—",
            created_at: <small>{note.createdAt ? new Date(note.createdAt).toLocaleDateString("fr-FR") : "—"}</small> });
          if (max > 0) { if (!results[lesson]) results[lesson] = []; results[lesson].push((score * 100) / max); }
        });
      });
      const labels = Object.keys(results);
      const data = labels.map((lesson) => Number((results[lesson].reduce((sum, score) => sum + score, 0) / results[lesson].length).toFixed(1)));
      this.setState({ rows, labels, data, loading: false, error: "" });
    } catch (error) { this.setState({ loading: false, error: "Impossible de charger les notes." }); }
  };

  render() {
    const columns = [
      { label: "Période", field: "Periode", sort: "asc", width: 70 },
      { label: "Cours", field: "lesson", sort: "asc", width: 150 },
      { label: "Note", field: "note", sort: "asc", width: 90 },
      { label: "Titulaire", field: "staff", sort: "asc", width: 150 },
      { label: "Date", field: "created_at", sort: "asc", width: 120 },
    ];
    return <div className="student-profile-results">
      <section className="ev-page-section student-profile-panel">
        <div className="ev-page-section__header"><div><span className="student-profile-section-kicker">Résultats</span><h2>Points — {this.props.title}</h2></div><FeatherIcon icon="clipboard" /></div>
        <div className="student-profile-result-body">
          {this.state.loading && <div className="student-profile-empty">Chargement des notes…</div>}
          {this.state.error && <div className="student-profile-empty is-error">{this.state.error}</div>}
          {!this.state.loading && !this.state.error && this.state.rows.length === 0 && <div className="student-profile-empty"><FeatherIcon icon="inbox" /><span>Aucune note pour cette catégorie.</span></div>}
          {this.state.rows.length > 0 && <Listprint columns={columns} rows={this.state.rows} title={this.props.title} matricule={this.props.matricule} name={this.props.name} classe={this.props.classe} />}
        </div>
      </section>
      {this.state.labels.length > 0 && <section className="ev-page-section student-profile-panel">
        <div className="ev-page-section__header"><div><span className="student-profile-section-kicker">Analyse</span><h2>Performance par cours</h2></div><FeatherIcon icon="trending-up" /></div>
        <div className="student-profile-result-body"><StudentLine data={this.state.data} labels={this.state.labels} title={`Statistique ${this.props.title} en %`} matricule={this.props.matricule} name={this.props.name} classe={this.props.classe} /></div>
      </section>}
    </div>;
  }
}
export default Reportcardnote;